export default "__VITE_ASSET__B80WOeRM__"